module.exports = __webpack_public_path__ + "img/noTestingList-icon.dd2af121.png";